import { useEffect, useState } from "react";
import moment from "moment";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import {
  respEnum,
  TournamentMatchStageEnum,
  TournamentMatchResultEnum,
  RoleEnum,
  TournamentVenueTypeEnum,
  TournamentMatchPlayStatusEnum,
} from "../../../constants/appConstant";
import {
  AppInput,
  AppSelect,
  AppSearchSelect,
} from "../../../components/appComponents";
import Card from "../../../components/ui/card-snippet";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { FiTrash, FiEdit2, FiPlay, FiAlertCircle, FiX } from "react-icons/fi";
import { FaUpload, FaRedo } from "react-icons/fa";
import Utility from "../../../helper/utilityHelper";
import MatchResultRefactor from "./components/matchResultRefactor";
import { useQueryParams } from "../../../contexts/queryParamsContext";

export const columns = [
  { key: "action", label: "Action" },
  /*{ key: "group", label: "Group" },*/
  { key: "typetournament", label: "Tournamanet" },
  { key: "team1", label: "Team 1" },
  { key: "vs", label: "" },
  { key: "team2", label: "Team 2" },
  { key: "venueName", label: "Venue Name" },
  { key: "courtName", label: "Court Name" },
  { key: "createdOn", label: "Schedule On" },
  { key: "isPlayed", label: "Played" },
  { key: "isResultUploaded", label: "Result Uploaded" },
  { key: "matchResult", label: "Match Result" },

  // { key: "winBy", label: "Win By" },
];

//const courts = [
//  { id: 0, name: "Select Court" },
//  { id: 64, name: "Court 1" },
//  { id: 65, name: "Court 2" },
//  { id: 66, name: "Court 3" },
//  { id: 67, name: "Court 4" },
//];

export default function Scheduling() {
  const [tournaments, setTournaments] = useState([]);
  const [tournamentId, setTournamentId] = useState();
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [tournament, setTournament] = useState({});
  const [scheduledMatches, setScheduledMatches] = useState([]);
  const [selectedTeam1, setSelectedTeam1] = useState();
  const [selectedTeam2, setSelectedTeam2] = useState();
  const [venueId, setVenueId] = useState();
  const [venueName, setVenueName] = useState();
  const [courtId, setCourtId] = useState();
  const [courtName, setCourtName] = useState();
  const [isDropdownEnabled, setIsDropdownEnabled] = useState(false);
  const [editId, setEditId] = useState(null);
  const [selectedTournamentType, setSelectedTournamentType] = useState();
  const [tournamentDetails, setTournamentDetails] = useState({});
  const [startDateTime, setstartDateTime] = useState();
  const [match, setMatch] = useState(null);
  const [venues, setVenues] = useState([]);
  const [venueType, setVenueType] = useState(null);
  const [courts, setCourts] = useState([]);
  const [tournamentCourts, SetTournamentCourts] = useState([]);
  const { params, setParams } = useQueryParams();

  const location = useLocation();
  const masterTournamentId = location.state?.masterTournamentId;
  const [isMatchResultRefactorOpen, setIsMatchResultRefactorOpen] =
    useState(false);
  const [id, setId] = useState();
  const navigate = useNavigate();

  const [tournamentType, setTournamentType] = useState(null);
  const [isResultUpload, setisResultUpload] = useState(null);
  const [team, setTeam] = useState(null);
  const [scheduledDate, setscheduledDate] = useState(null);
  const [tournamentVenueId, setTournamentVenueId] = useState(null);
  const [tournamentCourtId, setTournamentCourtId] = useState(null);
  const [filteredMatches, setFilteredMatches] = useState(scheduledMatches);
  const [selectedGroup, setSelectedGroup] = useState(null);

  // Check if user is Tournament Manager
  const isTournamentManager =
    Common.getUser()?.roleId === RoleEnum.Tournament_Manager;

  useEffect(() => {
    if (!isDropdownEnabled) {
      setSelectedTeam1();
      setSelectedTeam2();
      setSelectedTournamentType();
    }
  }, [isDropdownEnabled]);

  useEffect(() => {
    initialize();

    return () => {
      setParams({
        ...params,
        tournamentId: null,
      });
    };
  }, []);

  useEffect(() => {
    if (match) {
      setIsMatchResultRefactorOpen(true);
    }
  }, [match]);

  useEffect(() => {
    let t = tournaments.find((t) => t.id == id) || null;
    setTournament(t);
  }, [tournaments]);

  useEffect(() => {
    const filtered = scheduledMatches.filter((match) => {
      return (
        (!team ||
          match.team1 === team.teamName ||
          match.team2 === team.teamName) &&
        (!scheduledDate ||
          new Date(match.startDateTime).toDateString() ===
            new Date(scheduledDate).toDateString()) &&
        (!tournamentCourtId || match.courtId === tournamentCourtId) &&
        (!tournamentVenueId || match.venueId === tournamentVenueId) &&
        (!tournamentType || match.typetournament === tournamentType) &&
        (isResultUpload === null ||
          match.isResultUploaded === isResultUpload) &&
        (!selectedGroup ||
          match.group1 === selectedGroup ||
          match.group2 === selectedGroup)
      );
    });

    setFilteredMatches(filtered);
  }, [
    team,
    scheduledDate,
    tournamentCourtId,
    tournamentVenueId,
    tournamentType,
    isResultUpload,
    scheduledMatches,
    selectedGroup,
  ]);

  const resetFilters = () => {
    setisResultUpload(null);
    setTournamentType(null);
    setTeam(null);
    setscheduledDate(null);
    setTournamentCourtId(null);
    setTournamentVenueId(null);
    setSelectedGroup(null);
  };

  const initialize = async () => {
    debugger;
    const fetchedId = params.tournamentId;
    if (fetchedId) {
      setId(fetchedId);
      await getUnScheduleTournaments(fetchedId);
      await GetTournamentDetails(fetchedId);
      setIsDropdownEnabled(fetchedId !== null);
    } else {
      await getUnScheduleTournaments();
    }
  };

  const getCourts = async (venueId, tournamentVenue = false) => {
    debugger;

    if (venueType === TournamentVenueTypeEnum.Club_Wise && venueId) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await Common.ApiService.getInstance().request(
            `GetClubWiseCourtddl?clubId=${venueId}`
          );
          const data = [
            { id: null, name: "Select Court" },
            ...(response?.data ?? []),
          ];

          if (!tournamentVenue) setCourts(data);
          else SetTournamentCourts(data);
          resolve(data);
        } catch (error) {
          console.error("Error fetching courts:", error);
          reject(error);
        }
      });
    }

    if (!tournamentVenue) setCourts([{ id: null, name: "Select Court" }]);
    else SetTournamentCourts([{ id: null, name: "All" }]);
    return [];
  };

  const getVenues = async (tId, venueType) => {
    if (tId) {
      return new Promise(async (res) => {
        const response = await Common.ApiService.getInstance().request(
          `GetTournamentVenues?tournamentId=${tId}&type=${venueType ?? ""}`
        );
        const data = [
          { id: null, name: "Select Venue" },
          ...(response?.data ?? []),
        ];
        setVenues(data);
      });
    }
    setVenues([]);
  };

  const GetTournamentDetails = async (id) => {
    let response = await Common.ApiService.getInstance().request(
      `GetTournamentDetails?id=${id}`
    );
    debugger;

    let d = response?.data?.[0];
    setTournamentDetails(d);
    getVenues(d.id, d.venueType);
    setTournamentId(d.id);
    setVenueType(d.venueType);
    const mapMatches = d.matches.map((match) => ({
      ...match,
      typetournament: match.stageType,
      team1: match.teamAName,
      team2: match.teamBName,
      venueId: match.clubId ? match.clubId : match.cityId ? match.cityId : null,
      venueName: match.clubId
        ? match.clubName
        : match.cityId
        ? match.cityName
        : null,
      courtId: match.courtId,
      courtName: match.courtName,
      startDateTime: match.startDateTime,
      group1: match.group1,
      group2: match.group2,
    }));

    setScheduledMatches(mapMatches);
  };

  const getUnScheduleTournaments = async (id) => {
    const isTournamentManager = false; //global?.user?.roleId == RoleEnum.Tournament_Manager;
    const response = await Common.ApiService.getInstance().request(
      `GetUnScheduleTournaments${
        !isTournamentManager && id ? "?Schedule=true" : ""
      }`
    );
    if (response?.data) {
      let d = response?.data;
      let _data = d.map((tournament) => ({
        ...tournament,
        teams: tournament.teams.map((team) => ({
          ...team,
        })),
      }));
      setTournaments(_data);
    }
  };

  const changeTournament = (val) => {
    debugger;
    setTournamentId(val);
    setIsDropdownEnabled(tournamentId !== null);
    let t = tournaments.find((t) => t.id === val) || null;
    getVenues(val, t.venueType);
    setTournament(t);
    setVenueType(t.venueType);
    setScheduledMatches([]);
    setSelectedTeam1("");
    setSelectedTeam2("");
    setSelectedTournamentType(null);
    setEditId(null);
    setstartDateTime(null);
    setVenueId(null);
    setVenueName(null);
    setCourtId(null);
    setCourtName(null);
    resetFilters();
  };

  const handleAddTeam = () => {
    if (!selectedTournamentType) {
      Common.showToast("Select Tournament type");
      return;
    }

    if (!selectedTeam1 || !selectedTeam2) {
      Common.showToast("Please select both teams for a match");
      return;
    }
    if (selectedTeam1.id === selectedTeam2.id) {
      Common.showToast("The same team cannot play against itself");
      return;
    }

    //if (!VenueId || VenueId == 0) {
    //    setVenueId(null);
    //    setVenueName(null);
    //}

    //if (!courtId || courtId == 0) {
    //    setCourtId(null);
    //    setCourtName(null);
    //}

    if (!startDateTime) {
      Common.showToast("Please select match start date and time");
      return;
    }

    //if (!editId && moment(startDateTime).isBefore(moment())) {
    //    Common.showToast("Match start date and time cannot be in the past");
    //    return;
    //}

    // if (!Common.Utility.checkValidTimeOfDate(startDateTime)) {
    //     Common.showToast("Time of the start date format should be in 00, 30 or 23:59 format");
    //     return;
    // }

    const matchExists = scheduledMatches.some(
      (match) =>
        match.id !== editId &&
        ((match.team1 === selectedTeam1.teamName &&
          match.team2 === selectedTeam2.teamName &&
          match.typetournament === selectedTournamentType) ||
          (match.team1 === selectedTeam2.teamName &&
            match.team2 === selectedTeam1.teamName &&
            match.typetournament === selectedTournamentType))
    );

    if (matchExists) {
      Common.showToast(
        "Match is already scheduled for these teams in the tournament type"
      );
      return;
    }
    if (editId) {
      setScheduledMatches((prevMatches) => {
        return prevMatches.map((match) =>
          match.id === editId
            ? {
                ...match,
                team1: selectedTeam1.teamName,
                team2: selectedTeam2.teamName,
                group1: selectedTeam1.group,
                group2: selectedTeam2.group,
                typetournament: selectedTournamentType,
                startDateTime: startDateTime,
                venueId: venueId,
                venueName: venueName,
                courtId: courtId,
                courtName: courtName,
              }
            : match
        );
      });
      setEditId(null);
    } else {
      let newId;
      do {
        newId = Common.Utility.generateShortUniqueId();
      } while (scheduledMatches.some((match) => match.id === newId));

      setScheduledMatches((prevMatches) => [
        ...prevMatches,
        {
          id: newId,
          team1: selectedTeam1.teamName,
          team2: selectedTeam2.teamName,
          group1: selectedTeam1.group,
          group2: selectedTeam2.group,
          typetournament: selectedTournamentType,
          startDateTime: startDateTime,
          venueId: venueId,
          venueName: venueName,
          courtId: courtId,
          courtName: courtName,
        },
      ]);
    }

    setSelectedTeam1();
    setSelectedTeam2();
    setSelectedTournamentType(null);
    setVenueId();
    setVenueName();
    setCourtId();
    setCourtName();
    setstartDateTime();
  };

  const handleEdit = async (id) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    debugger;
    const match = scheduledMatches.find((match) => match.id === id);
    const team1 = tournament.teams.find(
      (team) => team.teamName === match.team1
    );
    const team2 = tournament.teams.find(
      (team) => team.teamName === match.team2
    );

    setSelectedTeam1(team1);
    setSelectedTeam2(team2);
    setSelectedTournamentType(match.typetournament);
    setVenueId(match.venueId);
    const fetchedCourts = await getCourts(match.venueId);
    const selectedCourt = fetchedCourts.find(
      (court) => court.id === match.courtId
    );
    setCourtId(match.courtId);
    setCourtName(selectedCourt ? selectedCourt.name : "");
    const selectedVenue = venues.find((v) => v.id === match.venueId);
    setVenueName(selectedVenue ? selectedVenue.name : "");
    setstartDateTime(match.startDateTime);
    setEditId(id);
  };

  const handleDelete = (id) => {
    setScheduledMatches((prevMatches) =>
      prevMatches.filter((match) => match.id !== id)
    );
    if (id === editId) {
      setEditId(null);
    }
  };

  const handlePlayMatch = async (id) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        `UpdateTournamentMatchStatus?id=${id}`,
        {
          tournamentScheduleId: id,
          playStatus: TournamentMatchPlayStatusEnum.In_Progress,
        },
        "POST"
      );

      if (response.status === respEnum.Success) {
        Common.SweetAlert.alert("Match started successfully");
        // Refresh data from API
        initialize();
      } else {
        Common.SweetAlert.alert(
          response.message || "Failed to start match",
          "error"
        );
      }
    } catch (error) {
      Common.SweetAlert.alert(
        "An error occurred while starting match",
        "error"
      );
      console.error("Error starting match:", error);
    }
  };

  const handleRemoveFromLive = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to remove this match from live status? This will change the match status back to pending.",
      "Remove from Live"
    );

    if (isConfirmed) {
      try {
        const response = await Common.ApiService.getInstance().request(
          `UpdateTournamentMatchStatus`,
          {
            tournamentScheduleId: id,
            playStatus: TournamentMatchPlayStatusEnum.Pending,
          },
          "POST"
        );

        if (response.status === respEnum.Success) {
          Common.SweetAlert.alert(
            "Match removed from live status successfully"
          );
          // Refresh data from API
          initialize();
        } else {
          Common.SweetAlert.alert(
            response.message || "Failed to remove match from live status",
            "error"
          );
        }
      } catch (error) {
        Common.SweetAlert.alert(
          "An error occurred while removing match from live status",
          "error"
        );
        console.error("Error removing from live:", error);
      }
    }
  };

  const Submit = async () => {
    debugger;
    setSaveBtnDisabled(true);

    try {
      if (!tournament || scheduledMatches.length < 0) {
        Common.showToast("Select Tournament & scheduled Matches", "Error");
        setSaveBtnDisabled(false);
        return;
      }
      let groupCounter = 0;
      let data = {
        tournamentId: tournament.id,
        matches: scheduledMatches.map((match) => {
          const teamAId = tournament.teams.find(
            (team) => team.teamName === match.team1
          )?.id;
          const teamBId = tournament.teams.find(
            (team) => team.teamName === match.team2
          )?.id;
          const matchId = typeof match.id === "string" ? 0 : match.id;

          return {
            id: matchId,
            teamAId: teamAId,
            teamBId: teamBId,
            stageType: match.typetournament,
            venueId: match.venueId,
            courtId: match.courtId,
            startDateTime: match.startDateTime,
          };
        }),
      };

      if (!data.tournamentId) {
        Common.showToast("Select Tournament", "Error");
        setSaveBtnDisabled(false);
        return;
      }

      if (data.matches.length === 0) {
        Common.showToast("At least one match must be scheduled", "Error");
        setSaveBtnDisabled(false);
        return;
      }

      //const teamIdsWithMatches = new Set(
      //  data.matches.flatMap((match) => [match.teamAId, match.teamBId])
      //);
      // const allTeamsHaveMatches = tournament.teams.every((team) =>
      //     teamIdsWithMatches.has(team.id)
      // );

      // if (!allTeamsHaveMatches) {
      //     Common.showToast(
      //         "Each team must have at least one scheduled match",
      //         "Error"
      //     );
      //     setSaveBtnDisabled(false);
      //     return;
      // }
      let endpoint = id ? "Rescheduling" : "TournamentScheduling";
      let resp = await Common.ApiService.getInstance().request(
        endpoint,
        data,
        "POST"
      );

      if (resp.status === respEnum.Success) {
        Common.SweetAlert.alert(resp.message);

        await GetTournamentDetails(tournament.id);
        // navigate("/app/tournaments");
      } else {
        Common.showToast("Error saving tournament", "Error");
      }
    } catch (error) {
      console.error(error);
      Common.showToast("Unexpected error", "Error");
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  return (
    <>
      <style>
        {`
          .margin-left {
            margin-left: 24px !important;
          }

          @media only screen and (max-width: 600px) {
          .margin-left {
            margin-left: 0px !important;
          }
          }

          .custom-card {
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            border: 2px solid #e2e8f0;
            border-radius: 16px;
            box-shadow: 0 10px 25px rgba(12, 27, 58, 0.1);
            transition: all 0.3s ease;
          }

          .custom-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(12, 27, 58, 0.15);
            border-color: #2E55B9;
          }

          .primary-button {
            background: linear-gradient(135deg, #2E55B9 0%, #0C1B3A 100%);
            border: none;
            border-radius: 12px;
            color: white;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(46, 85, 185, 0.3);
          }

          .primary-button:hover {
            background: linear-gradient(135deg, #0C1B3A 0%, #2E55B9 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(46, 85, 185, 0.4);
          }

          .live-badge {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            padding: 6px 12px;
            border-radius: 20px;
            font-weight: 700;
            font-size: 12px;
            letter-spacing: 0.5px;
            animation: pulse 2s infinite;
            box-shadow: 0 2px 10px rgba(239, 68, 68, 0.3);
          }

          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.8; }
          }

          .filter-card {
            background: linear-gradient(135deg, #0C1B3A 0%, #2E55B9 100%);
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 8px 25px rgba(12, 27, 58, 0.2);
          }

          .filter-card label {
            color: white !important;
          }

          .filter-card .text-gray-700,
          .filter-card .text-gray-800,
          .filter-card .text-gray-900 {
            color: white !important;
          }

          .action-button {
            border-radius: 8px;
            transition: all 0.2s ease;
          }

          .action-button:hover {
            transform: scale(1.1);
          }

          .match-table {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(12, 27, 58, 0.08);
          }

          .table-header {
            background: linear-gradient(135deg, #0C1B3A 0%, #2E55B9 100%);
            color: white !important;
          }

          .table-header th {
            color: white !important;
            font-weight: 600;
          }

          .group-badge {
            background: linear-gradient(135deg, #2E55B9 0%, #0C1B3A 100%);
            color: white;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 11px;
            font-weight: 600;
          }
        `}
      </style>

      <div className="space-y-6 mb-3">
        <Card
          title={
            <div className="text-center text-2xl font-bold text-[#0C1B3A]">
              🏆 Schedule Tournament
            </div>
          }
          className="custom-card"
        >
          <div className="md:grid md:grid-cols-3 gap-6 p-5">
            <div className="flex flex-col col-span-3">
              <div className="md:grid md:grid-cols-3 gap-6 mt-6">
                <div className="flex flex-col col-span-3">
                  <div className="md:grid md:grid-cols-2 gap-6 space-y-6 md:space-y-0">
                    <div className="flex flex-col col-span-5 gap-6">
                      {/* Tournament Selection Row */}
                      <div className="flex justify-center">
                        <div className="w-full max-w-md">
                          <AppSearchSelect
                            data={tournaments?.slice().reverse().map((item) => ({
                              id: item.id,
                              name: item.name,
                            }))}
                            placeholder="Select Tournament"
                            value={tournamentId}
                            label="Select Tournament"
                            onChange={(val) => changeTournament(val)}
                            disabled={id ? true : false}
                            className="whitespace-nowrap"
                          />
                        </div>
                      </div>

                      {/* Teams Display Row */}
                      {tournament?.teams?.length > 0 && (
                        <div className="w-full">
                          <div className="text-center mb-4">
                            <h3 className="text-xl font-bold text-[#0C1B3A] mb-2">
                              Teams
                            </h3>
                          </div>
                          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 p-3 sm:p-4 bg-gray-50 rounded-xl border-2 border-gray-200 max-h-32 overflow-y-auto">
                            {tournament.teams.map((team) => (
                              <div
                                key={team.id}
                                className="bg-gradient-to-r from-[#2E55B9] to-[#0C1B3A] text-white px-3 sm:px-4 py-2 rounded-full font-medium text-xs sm:text-sm shadow-md hover:shadow-lg transition-all duration-200 cursor-default whitespace-nowrap"
                              >
                                {team.teamName}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Match Scheduling Section - Hide for Tournament Manager */}
              {!isTournamentManager && (
                <div className="bg-white rounded-xl p-6 mt-8 border border-gray-200 shadow-sm">
                  <div
                    className={`grid gap-4 items-end ${
                      venueType == TournamentVenueTypeEnum.Club_Wise
                        ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-8"
                        : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7"
                    }`}
                  >
                    {/* Column 1: Match Type */}
                    <div className="col-span-1">
                      <AppSearchSelect
                        value={selectedTournamentType}
                        onChange={setSelectedTournamentType}
                        placeholder="Select Type"
                        label="Match Type"
                        data={[
                          { id: null, name: "Select" },
                          ...Common.Utility.enumToArray(
                            TournamentMatchStageEnum
                          ),
                        ]}
                        disabled={!isDropdownEnabled}
                      />
                    </div>

                    {/* Team Selection and VS Section */}
                    <div className="col-span-1">
                      <AppSearchSelect
                        data={
                          tournament?.teams && tournament.teams.length > 0
                            ? [
                                { id: "", name: "Select Team 1" },
                                ...tournament.teams.map((item) => ({
                                  id: item.id,
                                  name: item.teamName,
                                })),
                              ]
                            : []
                        }
                        placeholder="Select Team 1"
                        value={selectedTeam1 ? selectedTeam1.id : ""}
                        label="Team 1"
                        onChange={(val) => {
                          const team1 = tournament.teams.find(
                            (team) => team.id === val
                          );
                          setSelectedTeam1(team1);
                        }}
                        disabled={!isDropdownEnabled}
                      />
                    </div>

                    <div className="col-span-1 flex items-center justify-center">
                      <span className="text-xl font-bold text-[#0C1B3A] mt-6">
                        VS
                      </span>
                    </div>

                    <div className="col-span-1">
                      <AppSearchSelect
                        data={
                          tournament?.teams && tournament.teams.length > 0
                            ? [
                                { id: "", name: "Select Team 2" },
                                ...tournament.teams.map((item) => ({
                                  id: item.id,
                                  name: item.teamName,
                                })),
                              ]
                            : []
                        }
                        placeholder="Select Team 2"
                        value={selectedTeam2 ? selectedTeam2.id : ""}
                        label="Team 2"
                        onChange={(val) => {
                          const team2 = tournament.teams.find(
                            (team) => team.id === val
                          );
                          setSelectedTeam2(team2);
                        }}
                        disabled={!isDropdownEnabled}
                      />
                    </div>
                    <div className="col-span-1">
                      <AppSearchSelect
                        data={venues}
                        placeholder="Select Venue"
                        value={venueId ? venueId : null}
                        label="Venues"
                        onChange={(val) => {
                          debugger;
                          setCourtId(null);
                          setCourtName(null);
                          if (!val || val == 0) {
                            setVenueId(null);
                            setVenueName(null);
                            setCourts([{ id: null, name: "Select Court" }]);
                          } else {
                            debugger;
                            getCourts(val);
                            setVenueId(val);
                            const selectedVenues = venues.find(
                              (v) => v.id === val
                            );
                            setVenueName(
                              selectedVenues ? selectedVenues.name : ""
                            );
                          }
                        }}
                        disabled={!isDropdownEnabled}
                      />
                    </div>

                    <div className="col-span-1 mr-5">
                      <AppInput
                        value={startDateTime}
                        placeholder={"Start Time"}
                        label={"Start Time"}
                        type={"datetime-local"}
                        onChange={(value) => setstartDateTime(value)}
                      />
                    </div>

                    {/* Court - Only show if Club_Wise in the same row */}
                    {venueType == TournamentVenueTypeEnum.Club_Wise && (
                      <div className="col-span-1 mr-7">
                        <AppSearchSelect
                          data={courts}
                          placeholder="Select "
                          value={courtId ? courtId : null}
                          label="Court"
                          onChange={(val) => {
                            if (!val || val == 0) {
                              setCourtId(null);
                              setCourtName(null);
                            } else {
                              setCourtId(val);
                              const selectedCourt = courts.find(
                                (court) => court.id === val
                              );
                              setCourtName(
                                selectedCourt ? selectedCourt.name : ""
                              );
                            }
                          }}
                          disabled={!isDropdownEnabled || !venueId}
                        />
                      </div>
                    )}

                    {/* Add Match Button - Right Aligned */}
                    <div className="col-span-1 flex justify-end items-end">
                      <Button
                        className="primary-button px-6 py-3 font-semibold"
                        onClick={handleAddTeam}
                      >
                        {editId !== null ? "✏️ Update Match" : "➕ Add Match"}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Card>

        {scheduledMatches.length > 0 && (
          <div className="filter-card mt-8">
            <h3 className="text-white text-lg font-semibold mb-4 flex items-center">
              🔍 Filters & Search
            </h3>
            {/* Changed grid to 4 columns on large screens */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
              <div className="flex flex-col col-span-1 gap-5">
                <AppSearchSelect
                  data={
                    tournament?.teams && tournament.teams.length > 0
                      ? [
                          { id: "", name: "All " },
                          ...tournament.teams.map((item) => ({
                            id: item.id,
                            name: item.teamName,
                          })),
                        ]
                      : []
                  }
                  placeholder="All "
                  value={team ? team.id : ""}
                  label="Team"
                  onChange={(val) => {
                    debugger;
                    const teams = tournament.teams.find(
                      (team) => team.id === val
                    );
                    setTeam(teams);
                  }}
                  className="min-w-[190px] mt-2"
                />
              </div>

              <div className="flex flex-col col-span-1 gap-2 ml-4 margin-left">
                <AppInput
                  type={"date"}
                  value={scheduledDate}
                  onChange={setscheduledDate}
                  label="Scheduled Date"
                  className="mt-3"
                />
              </div>

              <div className="flex flex-col col-span-1 gap-2">
                <AppSearchSelect
                  data={venues}
                  placeholder="All"
                  value={tournamentVenueId ? tournamentVenueId : null}
                  label="Venue"
                  onChange={(val) => {
                    setTournamentCourtId(null);
                    if (!val || val == 0) {
                      setTournamentVenueId(null);
                      SetTournamentCourts([{ id: null, name: "All" }]);
                    } else {
                      setTournamentVenueId(val);
                      getCourts(val, true);
                    }
                  }}
                  className="mt-3"
                />
              </div>

              {venueType == TournamentVenueTypeEnum.Club_Wise && (
                <div className="flex flex-col col-span-1 gap-2">
                  <AppSearchSelect
                    data={tournamentCourts}
                    placeholder="All"
                    value={tournamentCourtId ? tournamentCourtId : null}
                    label="Court"
                    onChange={(val) => {
                      if (!val || val == 0) setTournamentCourtId(null);
                      else setTournamentCourtId(val);
                    }}
                    disabled={!tournamentVenueId}
                    className="mt-3"
                  />
                </div>
              )}
              <div className="flex flex-col col-span-1 gap-2 ">
                <AppSelect
                  value={tournamentType}
                  onChange={setTournamentType}
                  placeholder="All"
                  label="Match Type"
                  data={[
                    { id: null, name: "All" },
                    ...Common.Utility.enumToArray(TournamentMatchStageEnum),
                  ]}
                  className="mt-3"
                />
              </div>
              <div className="flex flex-col col-span-1 gap-2">
                <AppSelect
                  value={isResultUpload}
                  onChange={setisResultUpload}
                  label="Is Result Uploaded"
                  data={[
                    { id: null, name: "All" },
                    { id: true, name: "Yes" },
                    { id: false, name: "No" },
                  ]}
                  className="mt-3"
                />
              </div>
              <div className="flex flex-col col-span-1 gap-2">
                <AppSelect
                  value={selectedGroup}
                  onChange={setSelectedGroup}
                  label="Group"
                  data={[
                    { id: null, name: "All" },
                    ...Array.from(
                      new Set(
                        scheduledMatches
                          .flatMap((match) => [match.group1, match.group2])
                          .filter(
                            (group) => group != null && group !== undefined
                          )
                      )
                    )
                      .sort()
                      .map((group) => ({ id: group, name: `Group ${group}` })),
                  ]}
                  className="mt-3"
                />
              </div>
              <div className="flex flex-col col-span-1 gap-2">
                <Button
                  className="mt-9 h-10 max-w-[120px] bg-white text-[#0C1B3A] hover:bg-gray-100 font-semibold border-2 border-white"
                  onClick={resetFilters}
                >
                  🔄 Reset Filters
                </Button>
              </div>
            </div>
          </div>
        )}

        {scheduledMatches.length > 0 && filteredMatches.length === 0 && (
          <div className="flex flex-col items-center justify-center mt-6 p-4 ">
            <FiAlertCircle className="text-red-500 text-3xl mb-2" />
            <h2 className="text-xl font-semibold text-gray-700">
              No Records Found
            </h2>
            <p className="text-gray-600 mt-1">
              We couldn't find any matches based on your current filters.
            </p>
            <p className="text-gray-600">
              Please adjust your filters and try again.
            </p>
          </div>
        )}

        <div
          className="grid grid-cols-1 gap-6"
          style={{ maxWidth: "98%", margin: "0 auto" }}
        >
          {Object.keys(TournamentMatchStageEnum).map((type) => {
            const typeMatches = filteredMatches.filter(
              (match) => match.typetournament === TournamentMatchStageEnum[type]
            );
            //{Object.keys(TournamentMatchStageEnum).map((type) => {
            //    const typeMatches = scheduledMatches.filter(
            //        (match) => match.typetournament === TournamentMatchStageEnum[type]
            //    );
            if (typeMatches.length === 0) return null;
            return (
              <div key={type} className="max-w-full custom-card match-table">
                {/* Custom Centered Header */}
                <div className="text-center text-white font-bold text-2xl bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] p-6 rounded-t-xl mb-0">
                  🏆 {type.replace(/_/g, " ")}{" "}
                  {tournament?.name
                    ? `| ${
                        tournament.name.match(/\|([^|]+)\|/)?.[1] ||
                        tournament.name
                      }`
                    : ""}
                </div>
                <Card className="rounded-t-none">
                  <div className="flex flex-col">
                    <div
                      className="col-span-4"
                      style={{
                        /*maxHeight: "190px", overflowY: "auto",*/ textAlign:
                          "center",
                      }}
                    >
                      <Table>
                        <TableHeader className="table-header">
                          <TableRow>
                            {columns
                              .filter(
                                (column) =>
                                  venueType ==
                                    TournamentVenueTypeEnum.Club_Wise ||
                                  column.key !== "courtName"
                              )
                              .map((column) => (
                                <TableHead
                                  key={column.key}
                                  style={{
                                    display:
                                      column.key === "typetournament"
                                        ? "none"
                                        : "table-cell",
                                    textAlign: "center",
                                  }}
                                >
                                  {column.label}
                                </TableHead>
                              ))}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {typeMatches.map((match, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <div className="flex items-center">
                                  {/* For Tournament Manager: Only show result upload icon */}
                                  {isTournamentManager ? (
                                    <>
                                      {/* Result re-upload button */}
                                      {match.teamAId && match.results && (
                                        <FaRedo
                                          className="text-blue-500 cursor-pointer ml-2"
                                          onClick={() => {
                                            setMatch(match);
                                            setIsMatchResultRefactorOpen(true);
                                          }}
                                          title="Re-upload Result"
                                        />
                                      )}

                                      {/* Result upload button */}
                                      {match.teamAId && !match.results && (
                                        <FaUpload
                                          className="text-blue-500 cursor-pointer ml-2"
                                          onClick={() => {
                                            setMatch(match, tournament);
                                            setIsMatchResultRefactorOpen(true);
                                          }}
                                          title="Upload Result"
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {/* Show LIVE text when match is in progress */}
                                      {match.playStatus ===
                                        TournamentMatchPlayStatusEnum.In_Progress && (
                                        <span className="live-badge mr-2">
                                          🔴 LIVE
                                        </span>
                                      )}

                                      {/* Edit button - only show when not played and not in progress */}
                                      {!match.isPlayed &&
                                        match.playStatus !==
                                          TournamentMatchPlayStatusEnum.In_Progress && (
                                          <FiEdit2
                                            className="text-orange-500 cursor-pointer mr-2 action-button hover:text-orange-600"
                                            onClick={() => {
                                              /*getCourts(match.venueId); */ handleEdit(
                                                match.id
                                              );
                                            }}
                                            title="Edit Match"
                                          />
                                        )}

                                      {/* Play button - only show when not played and status is pending */}
                                      {match.teamAId &&
                                        (!match.playStatus ||
                                          match.playStatus ===
                                            TournamentMatchPlayStatusEnum.Pending) &&
                                        !match.isPlayed && (
                                          <FiPlay
                                            className="text-green-500 cursor-pointer mr-2 action-button hover:text-green-600"
                                            onClick={() =>
                                              handlePlayMatch(match.id)
                                            }
                                            title="Start Match"
                                          />
                                        )}

                                      {/* Remove from live button - only show when in progress */}
                                      {match.playStatus ===
                                        TournamentMatchPlayStatusEnum.In_Progress && (
                                        <FiX
                                          className="text-red-500 cursor-pointer mr-2 action-button hover:text-red-600"
                                          style={{
                                            fontSize: "20px",
                                            width: "20px",
                                            height: "20px",
                                          }}
                                          title="Remove from Live"
                                          onClick={() =>
                                            handleRemoveFromLive(match.id)
                                          }
                                        />
                                      )}

                                      {/* Delete button - only show when not played and not in progress */}
                                      {!match.isPlayed &&
                                        match.playStatus !==
                                          TournamentMatchPlayStatusEnum.In_Progress && (
                                          <FiTrash
                                            className="text-red-500 cursor-pointer action-button hover:text-red-600"
                                            onClick={() =>
                                              handleDelete(match.id)
                                            }
                                            title="Delete Match"
                                          />
                                        )}

                                      {/* Result re-upload button */}
                                      {match.teamAId && match.results && (
                                        <FaRedo
                                          className="text-blue-500 cursor-pointer ml-2"
                                          onClick={() => {
                                            setMatch(match);
                                            setIsMatchResultRefactorOpen(true);
                                          }}
                                          title="Re-upload Result"
                                        />
                                      )}

                                      {/* Result upload button */}
                                      {match.teamAId && !match.results && (
                                        <FaUpload
                                          className="text-blue-500 cursor-pointer ml-2"
                                          onClick={() => {
                                            setMatch(match, tournament);
                                            setIsMatchResultRefactorOpen(true);
                                          }}
                                          title="Upload Result"
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell style={{ display: "none" }}>
                                {type.replace(/_/g, " ")}
                              </TableCell>
                              {/*<TableCell>{match.group ?? "-"}</TableCell>*/}
                              <TableCell>
                                {match.team1} <br />
                                <span
                                  className={Utility.getGroupColor(
                                    match.group1
                                  )}
                                >
                                  (Group {match.group1})
                                </span>
                              </TableCell>
                              <TableCell>vs</TableCell>
                              <TableCell>
                                {match.team2} <br />{" "}
                                <span
                                  className={Utility.getGroupColor(
                                    match.group2
                                  )}
                                >
                                  (Group {match.group2})
                                </span>
                              </TableCell>
                              <TableCell>{match.venueName ?? "-"}</TableCell>
                              {venueType !=
                                TournamentVenueTypeEnum.City_Wise && (
                                <TableCell>{match.courtName ?? "-"}</TableCell>
                              )}
                              <TableCell>
                                {match.startDateTime
                                  ? Utility.formatDateTime(match.startDateTime)
                                  : "-"}
                              </TableCell>
                              <TableCell>
                                {match.isPlayed ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>
                                {match.isResultUploaded ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>
                                {" "}
                                {Common.Utility.getKeyByValue(
                                  TournamentMatchResultEnum,
                                  match.matchResult
                                ) || "No Result"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                </Card>
              </div>
            );
          })}
        </div>
      </div>

      {/* Hide Save Tournament button for Tournament Manager */}
      {!isTournamentManager && (
        <div className="flex flex-col items-end ">
          <Button
            onClick={Submit}
            disabled={saveBtnDisabled}
            className="primary-button min-w-[120px] h-12 text-lg font-semibold"
          >
            {saveBtnDisabled ? "💾 Saving..." : "💾 Save Tournament"}
          </Button>
        </div>
      )}
      <MatchResultRefactor
        isOpen={isMatchResultRefactorOpen}
        match={match}
        tournament={tournamentDetails}
        onClose={(refresh) => {
          setMatch(null);
          setIsMatchResultRefactorOpen(false);
          if (refresh) {
            initialize();
          }
        }}
      />
    </>
  );
}
